import axios from "axios";
// export const baseURL = "http://localhost:3021/v1";
export const baseURL = "https://fbrinvoicing.ebeaconsofts.com/v1";
// export const baseURL = "https://erpactivation.ebeaconsofts.com/v1";

export const headers = {
  "Content-Type": "application/json",
};

const instance = axios.create({
  baseURL: baseURL,
  headers: headers,
  responseType: "json",
});

// The token is read per request rather than baked into the instance defaults.
// Reading it once at module load meant the Authorization header kept whatever
// was in localStorage when the bundle first ran, so a fresh login kept sending
// the previous (or missing) token until the page was reloaded.
instance.interceptors.request.use((config) => {
  const token = window.localStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  } else {
    delete config.headers.Authorization;
  }
  return config;
});

instance.interceptors.response.use(
  (response) => response,
  (error) => {
    // A request that never reached the server (offline, timeout, CORS, aborted)
    // has no `response`. Reading `.status` off it threw a TypeError from inside
    // the interceptor, which replaced the real failure with a confusing one.
    if (error?.response?.status === 401) {
      window.localStorage.clear();
      window.location.replace("/login");
    }
    return Promise.reject(error);
  },
);

/**
 * The message to show for a failed request.
 *
 * The server's own message whenever it sent one - exactly what the screens
 * showed before. Otherwise a sentence saying what happened. The catch handlers
 * used to read `error.response.data.message` directly, and with this axios
 * (0.27) a request that got no answer has no `data` (offline, Wi-Fi drop,
 * server down: `response` is the bare request with status 0; a timeout: no
 * `response` at all). That read threw inside the catch, so the screen's error
 * action never ran and its loading spinner never stopped.
 */
export const apiErrorMessage = (error) => {
  const message = error?.response?.data?.message;
  if (message) return message;
  const status = error?.response?.status;
  if (status) {
    return `The server could not complete the request (error ${status}). Please try again.`;
  }
  return "Could not reach the server. Please check your internet connection and try again.";
};

export default instance;
